import React from "react";

export const Electricity = [
  <div className="slideContainer slideContainerVideo">
  <h4 className="slideTitle">How can renewable electricity help fight climate change? | Electricity</h4>
  <div class="video_container">
    <video width="320" height="240" controls>
      <source
        src="videos/How-can-renewable-electricity-help-fight-climate-change.mp4"
        type="video/mp4"
      />
    </video>
  </div>
  <div className="qrCode">
    <div className="qrText">
      <p>
        <span>Scan the QR code</span> to watch the video on YouTube.
      </p>
    </div>
    <div className="qrImage">
      <img src="images/qr/qr-renewable-energy-fight-climate-change.svg" width="auto" height="95px" alt="" />
    </div>
  </div>
</div>,
  <>
    <h4 class="slideTitle mb-1">Our customer value proposition</h4>

    <div className="slideContainer slide_solidColour">
      <div className="colLeft col30">
        <p>
          <strong>Investments and acquisitions</strong>
        </p>
        <ul className="shell_bullets_list">
          <li className="mb-1">Ubitricity, UK, 2021</li>
          <li className="mb-1">Next Kraftwerke, Germany, 2021</li>
          <li className="mb-1">Emerald floating wind project, Ireland, 2021</li>
          <li className="mb-1">Qabas solar plant, Oman, 2021</li>
          <li className="mb-1">Hollandse Kust (noord), 2020</li>
          <li className="mb-1">Gangarri, Australia, 2020</li>
          <li className="mb-1">ERM Power (Shell Energy), Australia, 2019</li>
          <li className="mb-1">EOLFI, FR, 2019</li>
          <li className="mb-1">
            Hudson Energy, UK, 2019 (Shell Energy Retail)
          </li>
          <li className="mb-1">Limejump, UK, 2019</li>
          <li className="mb-1">sonnen, Germany, 2019</li>
          <li className="mb-1">Greenlots, USA, 2019</li>
          <li className="mb-1">
            First Utility, UK, 2018 (Shell Energy Retail)
          </li>
          <li className="mb-1">Borssele 3 and 4, Netherlands, 2018</li>
          <li className="mb-1">Silicon Ranch, USA, 2018</li>
          <li className="mb-1">Cleantech Solar, Singapore, 2018</li>
          <li className="mb-1">NewMotion, UK and Europe, 2017</li>
          <li className="mb-1">Shell Recharge, UK, 2017</li>
          <li className="mb-1">MP2 Energy, USA, 2017</li>
          <li className="mb-1">WonderBill, UK, 2015</li>
        </ul>
      </div>
      <div className="colRight col70">
        <img src="images/electricity.jpg" width="100%" height="auto" alt="" />
      </div>
    </div>
  </>,
];
